import lyttlApi from "../intercepter/keycloakInterceptor";

export const lttlService = {
  async createShortUrl(body) {
    const res = await lyttlApi.post(`/shortUrl/create`, body);
    return res.data;
  },
  async updateShortURL(shortCode, body) {
    const res = await lyttlApi.put(`/shortUrl/${shortCode}`, body);
    return res.data;
  },

  async getLinkDetails(shortCode) {
    return lyttlApi.get(`/shortUrl/${shortCode}`);
  },

  // async createDeepLink(data) {
  //   return lyttlInstance.post("/sortURl/create", data);
  // },
};
